import { render, staticRenderFns } from "./EditTemplateGroup.vue?vue&type=template&id=0773b8de&scoped=true&"
import script from "./EditTemplateGroup.vue?vue&type=script&lang=js&"
export * from "./EditTemplateGroup.vue?vue&type=script&lang=js&"
import style0 from "./EditTemplateGroup.vue?vue&type=style&index=0&lang=css&"
import style1 from "./EditTemplateGroup.vue?vue&type=style&index=1&id=0773b8de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0773b8de",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardActions,VCol,VDataTable,VDialog,VIcon,VRow,VSelect,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/-36BVGaF/0/applicationg/aims-dashboard/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0773b8de')) {
      api.createRecord('0773b8de', component.options)
    } else {
      api.reload('0773b8de', component.options)
    }
    module.hot.accept("./EditTemplateGroup.vue?vue&type=template&id=0773b8de&scoped=true&", function () {
      api.rerender('0773b8de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Template/modal/EditTemplateGroup.vue"
export default component.exports